var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-container"},[_c('vue-autosuggest',{attrs:{"suggestions":_vm.suggestions,"input-props":{
      id: 'autosuggest__input',
      placeholder: 'Search for cheers or bitches',
      class: 'form-control'
    },"get-suggestion-value":_vm.getSuggestionValue},on:{"input":_vm.onInputChange,"selected":_vm.onSelected},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var suggestion = ref.suggestion;
return [_vm._v(" ("+_vm._s(suggestion.item.type)+") "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.bolden(_vm.query, suggestion.item.text))}})]}}]),model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }